export default [
  {
    // Greendale Community College
    id: '1',
    name: 'WONDE',
    active: true,
  },
  {
    // City College
    id: '2',
    name: 'WONDE',
    active: true,
  },
  {
    // Athabasca High School
    id: '3',
    name: 'WONDE',
    active: true,
  },
  {
    // Brazeau Elementary School
    id: '4',
    name: 'WONDE',
    active: true,
  },
  {
    // Doyle Elementary School
    id: '5',
    name: 'WONDE',
    active: true,
  },
  {
    // Alaska Elementary School
    id: '6',
    name: 'WONDE',
    active: true,
  },
  {
    // Hogwarts School
    id: '7',
    name: 'WONDE',
    active: true,
  },
];
